import * as Scrivito from "scrivito";

function ContactImage({ page }) {
  const image = page.get("image");
  const resizedImage = image
    .get("blob")
    ?.optimizeFor({ width: 270, height: 270, fit: "resize" });

  return (
    <img
      alt={page.get("title")}
      className="profile-pic"
      src={Scrivito.urlFor(resizedImage)}
      width="270"
      height="270"
    />
  );
}

export default Scrivito.connect(ContactImage);
